import '@babel/polyfill'
import 'url-search-params-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom'

import { Provider } from 'react-redux'
import indexRoutes from './routes/index.jsx'
import { ApolloProvider } from 'react-apollo'
import history from './history'
import './assets/css/style.css'
import configureStore from './configureStore'
import client from './configureApolloClient'

const { store } = configureStore()

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          {indexRoutes.map((prop, key) => <Route path={prop.path} component={prop.component} key={key} />)}
        </Switch>
      </Router>
    </Provider>
  </ApolloProvider>,

  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js